import React from 'react';
import { connect } from 'react-redux';

import Form from 'src/explore/compositions/ForgotPassword';
import * as actions from './actions';

export const ForgotPassword = ({ close, defaultEmail, visible }) => {
  if ( !visible ) return null;

  return (
    <div className="modal spec__forgot-password-modal">
      <div className="modal-dialog v2-modal__modal-dialog">
        <span className="close-button close" onClick={close} />

        <div className="modal-content v2-modal__container">
          <main className="v2-modal__main">
            <div className="v2-modal__main-header text-center">
              <div className="v2-modal__section__title">Reset Your Password</div>
            </div>

            <div className="bs4">
              <Form
                className="text-center"
                defaultEmail={defaultEmail}
                onBack={close}
                onClose={close}
              />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ( state ) => ({
  visible: state.ForgotPassword.visible,
  defaultEmail: state.ForgotPassword.defaultEmail,
});

const mapDispatchToProps = {
  close: () => actions.close(),
};

export default connect( mapStateToProps, mapDispatchToProps )( ForgotPassword );
